import React, { useState } from 'react'
import { motion } from 'framer-motion'
import Portal from '../../Portal'
import Close from 'public/assets/svg/close.svg'
import injectSheet from 'react-jss'
import styleSheet from './styles'

const Message = props => {
    // Destructure props //
    const { classes, onClose, title, message } = props

    // Local state //
    const [promptAnimationComplete, setPromptAnimationComplete] = useState(false)

    // Animations //
    const sceneAnimations = {
        open: {
            opacity: 1,
            transition: {
                duration: 0.5,
                onComplete: () => {
                    setTimeout(() => {
                        setPromptAnimationComplete(true)
                    }, 4000)
                },
            },
        },
        closed: {
            opacity: 0,
            transition: {
                duration: 0.5,
                onComplete: onClose,
            },
        },
    }

    return (
        <Portal>
            <motion.div
                initial={{ opacity: 0 }}
                animate={promptAnimationComplete ? 'closed' : 'open'}
                variants={sceneAnimations}
                className={classes.switchToMap}
            >
                <button onClick={() => setPromptAnimationComplete(true)} type="button" className={classes.closePrompt}>
                    <Close />
                </button>
                <h2>{title}</h2>
                <p>{message}</p>
            </motion.div>
        </Portal>
    )
}

Message.defaultProps = {
    classes: [],
    onClose: Function,
    title: '',
    message: '',
}

export default injectSheet(styleSheet)(Message)
